// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"f712494d","1970":"1e74590f","2338":"36b425b9","4002":"ed0d9e57","5035":"2069fe87","5225":"5de634d7","6497":"974ce9c6","6507":"5de634d7","8041":"4acd34eb"}[chunkId] + ".chunk.css";
};